import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { resolveOverlayStatus, SpeechProvider, SttUIStatus } from '../../models/stt-chunked.model';

export type TranscriptStatus = 'listening' | 'processing' | '';

@Component({
  selector: 'cva-transcript-overlay',
  standalone: false,
  templateUrl: './transcript-overlay.component.html',
  styleUrl: './transcript-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranscriptOverlayComponent implements OnChanges {
  @Input() provider: SpeechProvider = 'audio-chunks';   // default keeps the old behaviour
  @Input() recording = false;
  @Input() status: TranscriptStatus = '';
  @Input() liveText: boolean | null = null;
  @Input() hasTranscript = false;
  @Output() micClick = new EventEmitter<void>();

  peek = false;


  ngOnChanges(): void {
    if (this.effectiveStatus || this.liveText) this.peek = false;   // recording starts or live text switched on: back to normal
  }

  get effectiveStatus(): SttUIStatus {
    return resolveOverlayStatus(this.provider, this.recording, this.status);
  }

  get pillText(): string {
    if (this.effectiveStatus === 'processing') return 'Finishing up…';
    return this.hasTranscript
      ? 'Waiting for the next lines…'
      : 'Live text is on. Waiting for the first lines…';
  }

  get showPanel(): boolean {
    return this.liveText === false && !(this.peek && !this.effectiveStatus && this.hasTranscript);
  }

}